import { Container, Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { UIView } from "@uirouter/react";
import * as React from "react";
import styled from "styled-components";
import { useGlobalNotifications } from "../../../components/hooks/use-global-notification";
import { columnFlex, FullSize } from "../../../components/layout";
import { colours } from "../../../styles/colours";
import { ExternalShellContext } from "./context";

type IExternalLaunchShellProps = {};

const Page = styled.div<{ hasBackground?: boolean }>`
  ${columnFlex}
  ${FullSize}
  overflow: auto;
  ${({ hasBackground }) => hasBackground && "background-color: " + colours.grey}
`;

const StyledContainer = styled(Container)`
  padding: 1em;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const ExternalLaunchShell: React.FunctionComponent<IExternalLaunchShellProps> = (
  props
) => {
  const { notification, handleClose } = useGlobalNotifications();
  const [hasBackground, setHasBackground] = React.useState(false);

  return (
    <Page hasBackground={hasBackground}>
      <UIView name="header" />
      <StyledContainer maxWidth="lg">
        <ExternalShellContext.Provider
          value={{ hasBackground, setHasBackground }}
        >
          <UIView name="extra" />
          <UIView />
        </ExternalShellContext.Provider>
      </StyledContainer>
      <Snackbar
        open={!!notification}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert onClose={handleClose} severity={notification?.variant}>
          {notification?.title}
        </MuiAlert>
      </Snackbar>
      <UIView name="footer" />
    </Page>
  );
};

export default ExternalLaunchShell;
